"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGFCloseOrderInfo = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const trade_quotation_lib_1 = require("trade_quotation_lib");
const trade_utils_lib_1 = require("trade_utils_lib");
const GridTradingUtils_1 = require("../GridTradingUtils");
const QUOTE_STABLE_COIN = "USDT";
const useGFCloseOrderInfo = ({ order, tradeAPI, displayToU = true, }) => {
    var _a;
    const { base, quote } = order;
    const isUSDTOrder = quote === QUOTE_STABLE_COIN;
    const baseQuoteTicker = (0, trade_quotation_lib_1.useTicker)({ base, quote });
    const quoteUTicker = (0, trade_quotation_lib_1.useTicker)({ base: quote, quote: QUOTE_STABLE_COIN, isActive: !isUSDTOrder });
    const gridOrder = order.exchangeGridV4FuturesOrder;
    const symbolInfo = (0, trade_utils_lib_1.getTradeDependencyInstance)().getSymbolInfo(`${base}/${quote}`);
    const quoteToUSymbol = (0, trade_utils_lib_1.getTradeDependencyInstance)().getSymbolInfo(`${quote}/${QUOTE_STABLE_COIN}`);
    // 获取合约网格平仓的手续费率
    const [baseQuoteFeeRate] = GridTradingUtils_1.GridTradingUtils.useFeeRate(symbolInfo, tradeAPI, TradeAPILib_1.ExchangeID.PIONEXV2, "taker");
    // 卖quote的手续费率
    const [quoteUFeeRate] = GridTradingUtils_1.GridTradingUtils.useFeeRate(quoteToUSymbol, tradeAPI, TradeAPILib_1.ExchangeID.PIONEXV2, "taker");
    // 是否为发财金单
    const isBonusOrder = (gridOrder === null || gridOrder === void 0 ? void 0 : gridOrder.investment_from) === TradeAPILib_1.GridFuturesInvestmentFrom.FUTURE_GRID_BONUS;
    /** 是否为后端swap订单 */
    const isSwapOrder = (gridOrder === null || gridOrder === void 0 ? void 0 : gridOrder.invest_coin) && gridOrder.invest_coin !== quote;
    /** 是否需要转换为U的单位: 需要转成USDT 并且不是USDT订单 */
    const isNeedChangeToUSDT = displayToU && !isUSDTOrder;
    /** 需要转换成USDT单位的话, 需要乘以quote/USDT的价格  */
    const mulPrice = new trade_utils_lib_1.SafeDecimal(isNeedChangeToUSDT ? quoteUTicker === null || quoteUTicker === void 0 ? void 0 : quoteUTicker.latest : 1);
    /** 机器人总权益 保证金余额 + 未实现盈亏 */
    const asset = new trade_utils_lib_1.SafeDecimal(gridOrder === null || gridOrder === void 0 ? void 0 : gridOrder.margin_balance)
        .add(new trade_utils_lib_1.SafeDecimal(baseQuoteTicker === null || baseQuoteTicker === void 0 ? void 0 : baseQuoteTicker.latest)
        .sub(new trade_utils_lib_1.SafeDecimal(gridOrder === null || gridOrder === void 0 ? void 0 : gridOrder.position_open_price))
        .mul(new trade_utils_lib_1.SafeDecimal(gridOrder === null || gridOrder === void 0 ? void 0 : gridOrder.position)))
        .mul(mulPrice);
    /** 投资额 */
    let invest = new trade_utils_lib_1.SafeDecimal(gridOrder === null || gridOrder === void 0 ? void 0 : gridOrder.quote_investment).mul(mulPrice);
    if (isSwapOrder) {
        // 后端转换. 投资额用usdt_investment
        invest = new trade_utils_lib_1.SafeDecimal(gridOrder === null || gridOrder === void 0 ? void 0 : gridOrder.usdt_investment);
    }
    /** 额外保证金 */
    const extraMargin = new trade_utils_lib_1.SafeDecimal(gridOrder === null || gridOrder === void 0 ? void 0 : gridOrder.extra_margin).mul(mulPrice);
    /** 总利润 总权益 - 投资额 - 额外保证金 */
    const totalProfit = asset.sub(invest).sub(extraMargin);
    /** 平仓手续费 */
    const closePositionFee = new trade_utils_lib_1.SafeDecimal((_a = order.exchangeGridV4FuturesOrder) === null || _a === void 0 ? void 0 : _a.position)
        .abs()
        .mul(new trade_utils_lib_1.SafeDecimal(baseQuoteTicker === null || baseQuoteTicker === void 0 ? void 0 : baseQuoteTicker.latest))
        .mul(new trade_utils_lib_1.SafeDecimal(baseQuoteFeeRate))
        .mul(mulPrice);
    /** 平仓后的权益 */
    const closedAsset = asset.sub(closePositionFee);
    /** 卖出quote手续费, 仅在需要转换时需要 */
    const sellQuoteFee = isNeedChangeToUSDT ? closedAsset.mul(new trade_utils_lib_1.SafeDecimal(quoteUFeeRate)) : new trade_utils_lib_1.SafeDecimal(0);
    /** 关单手续费 =  */
    const closeFee = closePositionFee.add(sellQuoteFee);
    /** 已提取利润 */
    const profitWithdrawn = new trade_utils_lib_1.SafeDecimal(gridOrder === null || gridOrder === void 0 ? void 0 : gridOrder.profitWithdrawn).mul(mulPrice);
    /** 分润比例 */
    const shareRatio = new trade_utils_lib_1.SafeDecimal(gridOrder === null || gridOrder === void 0 ? void 0 : gridOrder.share_ratio);
    /** 发财金服务费比例 */
    const bonusFeeRatio = new trade_utils_lib_1.SafeDecimal(gridOrder === null || gridOrder === void 0 ? void 0 : gridOrder.bonus_fee_ratio);
    let bonusFee = new trade_utils_lib_1.SafeDecimal(0);
    /** 如果是发财金订单 要计算发财金服务费 */
    if (isBonusOrder) {
        /** 发财金服务费 (总利润 - 平仓手续费) * 服务费比例 */
        bonusFee = totalProfit.sub(closeFee).mul(bonusFeeRatio);
        // 赔钱不分润
        bonusFee = trade_utils_lib_1.SafeDecimal.max(0, bonusFee);
    }
    /** 如果不是发财金订单 分润费 (总利润 + 已提取利润 - 平仓手续费) * 分润比例 */
    /** 发财金订单 分润费 (总利润 - 平仓手续费) * 分润比例 */
    let shareValue = totalProfit
        .add(isBonusOrder ? 0 : profitWithdrawn)
        .sub(closeFee)
        .mul(shareRatio);
    // 赔钱不分润
    shareValue = trade_utils_lib_1.SafeDecimal.max(0, shareValue);
    // 分的太多, 最多给平仓后的最大权益
    shareValue = trade_utils_lib_1.SafeDecimal.min(closedAsset, shareValue);
    /** 回收资金 */
    let backAmount = new trade_utils_lib_1.SafeDecimal(0);
    if (isBonusOrder) {
        /** 可用于回收的钱 平仓后的权益 - 额外保证金 - 分润费用 */
        const canBack = closedAsset.sub(extraMargin).sub(sellQuoteFee).sub(shareValue);
        /** 需要回收的发财金 (仅支持USDT) */
        const needBack = new trade_utils_lib_1.SafeDecimal(gridOrder.usdt_investment);
        backAmount = trade_utils_lib_1.SafeDecimal.min(canBack, needBack);
    }
    /** 预期结算资金 */
    const settlement = closedAsset.sub(sellQuoteFee).sub(shareValue).sub(bonusFee).sub(backAmount);
    /** 投资额精度 */
    const precisionCost = isNeedChangeToUSDT ? quoteToUSymbol === null || quoteToUSymbol === void 0 ? void 0 : quoteToUSymbol.precisionCost : symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precisionCost;
    return {
        settlement: settlement,
        investPrecision: precisionCost !== null && precisionCost !== void 0 ? precisionCost : 2,
        asset,
        investment: invest,
        totalProfit,
        extraMargin,
        closeFee,
        bonusFee,
        bonusFeeRatio,
        shareValue,
        shareRatio,
        backToSystem: backAmount,
        baseQuoteSymbol: symbolInfo,
        quoteToUSymbol: quoteToUSymbol,
        isNeedChangeToUSDT,
    };
};
exports.useGFCloseOrderInfo = useGFCloseOrderInfo;
